import type { ColumnDef } from '@tanstack/vue-table'
import DataTableGoto from 'pejer/src/components/Table/core/DataTableGoto.vue'
import { h } from 'vue'

import * as Business from '../../tables/Businesses'

// This type is used to define the shape of our data.
// You can use a Zod schema here if you want.
export const businessColumns: ColumnDef<Business.ListItem>[] = [
  {
    accessorKey: 'name',
    size: 250,
  },
  {
    accessorKey: 'organizationId',
  },
  {
    accessorKey: 'tosAcceptedAt',
  },
  {
    accessorKey: 'signatureCompletedAt',
  },
  {
    accessorKey: 'insertTime',
  },
  {
    id: 'actions',
    meta: {
      placement: 'end',
    },
    size: 40,
    cell: ({ row }) => {
      return h(
        'div',
        { style: { display: 'flex', justifyContent: 'end' } },
        h(DataTableGoto, {
          id: {
            countryCode: row.original.countryCode,
            organizationId: row.original.organizationId,
          },
          pathName: 'business',
        })
      )
    },
  },
]
